import { render, staticRenderFns } from "./GitMerge.vue?vue&type=template&id=1b76c7f8&scoped=true"
import script from "./GitMerge.vue?vue&type=script&lang=js"
export * from "./GitMerge.vue?vue&type=script&lang=js"
import style0 from "./GitMerge.vue?vue&type=style&index=0&id=1b76c7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b76c7f8",
  null
  
)

export default component.exports